import React from "react";
import { Tag } from "@jsq/ds/core";
import { type ArenaGroup } from "~/graphql/supergraphTypes";
import { getArenaGroupsDisplayInfo } from "./utils";

interface ArenaGroupsDisplayProps {
  arenaGroups: ArenaGroup[];
}

const ArenaGroupsDisplay: React.FC<ArenaGroupsDisplayProps> = ({ arenaGroups }) => {
  const displayInfo = getArenaGroupsDisplayInfo(arenaGroups);

  return <Tag variant={displayInfo.variant}>{displayInfo.text}</Tag>;
};

export default ArenaGroupsDisplay;
